require('../../scripts/engine.js')
require('../../scripts/cache.js')
require('../../scripts/network.js')
require('../../scripts/server.js')
require('../../scripts/formula.js')
require('../../scripts/manifest.js')
require('../../scripts/wasm.js')
require('../../scripts/wasm_go')

class KolmoApplication
{
    constructor(dedicated_server_address, Use_localStorage)
    {
        let options = {
            Network: {
                DedicatedServer: dedicated_server_address
            },
            Cache: {
                Use_localStorage: Use_localStorage
            }
        };

        this.engine = new global.Engine(options)

        this.update_manifest = null;
        this.update_data_view = null;

        this.current_manifest = null;
        this.current_manifest_status = "Not defined";

        this.manifest_focus_list = []
    }

    setUpdateManifest(update_manifest){
        this.update_manifest = update_manifest
    }

    setUpdateDataView(update_data_view){
        this.update_data_view = update_data_view
    }

    updateDataView(data)
    {
        if (null != this.update_data_view)
            this.update_data_view(data)
    }

    getCache() {
        return this.engine.cache()
    }

    getNetwork() {
        return this.engine.network()
    }

    getCurrentManifest()
    {
        let result = {
            status: "ok",
            data: null
        };

        result.data = this.current_manifest;
        result.status = this.current_manifest_status;

        return result
    }

    setNewManifest(str_manifest)
    {
        if (null == str_manifest)
        {
            this.current_manifest = null;
            this.current_manifest_status = "Not defined";

            this.update_manifest();

            return
        }

        this.manifest_focus_list = []

        this.current_manifest = null;
        this.current_manifest_status = "Not defined";

        try
        {
            this.current_manifest = new global.Manifest(JSON.parse(str_manifest));
            this.current_manifest_status = "ok";
        }
        catch(error)
        {
            this.current_manifest_status = "Error creating manifest: " + error
        }

        if (null !== this.update_manifest)
            this.update_manifest();
    }

    PushManifestFocusList(manifest)
    {
        if (0 === this.manifest_focus_list.length)
            this.manifest_focus_list.push({ data:this.current_manifest, status:this.current_manifest_status })
        
        this.manifest_focus_list.push({ data:manifest.data, status:manifest.status })

        this.current_manifest = manifest.data;
        this.current_manifest_status = manifest.status;

        if (null !== this.update_manifest)
            this.update_manifest();
    }

    PopManifestFocusList()
    {
        let manifest = this.manifest_focus_list.pop()

        if (null != manifest)
        {
            manifest = this.manifest_focus_list.pop()

            if (null != manifest)
            {
                this.current_manifest = manifest.data;
                this.current_manifest_status = manifest.status;

                if (null !== this.update_manifest)
                    this.update_manifest();
            }
        }
    }

    ManifestFocusListIsEmpty(){
        return (0 === this.manifest_focus_list.length) ? true : false
    }
}

export default KolmoApplication;
